const locale = {
  Enabled: "مفعل",
  Disabled: "معطل",
  IVRREJECTED: "IVR مرفوض",
  NAV: {
    HOME: "الرئيسية",
    APPLY: "التقديم",
    HOW_IT_WORKS: "كيف تعمل؟",
    ABOUT: "حول",
    FINANCIAL_PRODUCT: "المنتج المالي",
    CONTACT: "اتصل بنا",
    FAQS: "الأسئلة الشائعة",
  },
  SIGN_IN: {
    LOGIN: "تسجيل الدخول",
    TITLE: "تسجيل الدخول",
    DESCRIPTION: "أكثر من تمويل",
    FIELDS: {
      ID: "الهوية الوطنية / الإقامة",
      PASSWORD: "كلمة السر",
    },
    FORGOT_PASSWORD: "هل نسيت كلمة السر؟",
    DONT_HAVE_AN_ACCOUNT: "لا تملك حساباً؟",
    SIGN_UP: "أفتح حساب الأن",
    ID_10_DIGITS: "يجب أن يتكون رقم الهوية من 10 أرقام بالضبط.",
    CANNOT_BE_EMPTY: "لا يمكن أن يكون فارغًا.",
    CREDENTIAL_SUCCESS: "تم التحقق من البيانات بنجاح",
    SOMETHING_WENT_WRONG: "حدث خطأ ما",
    TIMEOUT: "انتهت المهلة. يرجى تسجيل الدخول مرة أخرى",
    VERIFICATION_COMPLETE: "اكتمل التحقق",
    WRONG_OTP: "رمز التحقق غير صحيح!",
    SEND: "إرسال",
    RESEND_CODE: "إعادة إرسال الرمز",
    WE_HAVE_SENT: "لقد أرسلنا كلمة المرور المؤقتة (OTP) عبر الرسائل القصيرة",
    HELP_LINE_CALL: "للمساعدة يرجي الاتصال بهذا الرقم: ٩٢٠٠٠٥٤٧٧",
    CALL_FOR_SUPPORT: "اتصل للدعم",
    EMAIL_US_AT: "راسلنا على",
    TICKET_SUBMISSION: "تقديم تذكرة",
    OR: "أو",
    HELP_LINE_EMAIL: "ارسل بريد إلكتروني إلى: info@tamweel-aloula.com",
    INVALID_CREDENTIALS: "بيانات الاعتماد غير صحيحة (المعرف أو كلمة المرور).",
    ACCOUNT_DELETED: "تم حذف الحساب.",
    DEVICE_REGISTRATION_LIMIT_REACHED:
      "تم الوصول إلى الحد الأقصى لتسجيل الأجهزة.",
    IVR_NOT_VERIFIED: "لم يتم التحقق من الجهاز عن طريق المكالمة.",
    DEVICE_NOT_REGISTERED: "هذا الجهاز غير مسجل.",
    LOGIN_FAILED: "حدث خطأ غير متوقع، يرجى المحاولة مرة أخرى لاحقاً.",
    HELP_AND_SUPPORT: "المساعدة والدعم",
    CHANGE_MOBILE_NUMBER: "تغيير رقم الجوال",
    CHANGE_MOBILE_DESC: "أدخل تفاصيلك أدناه لتحديث رقم جوالك المسجل.",
    NATIONAL_ID: "رقم الهوية / الإقامة",
    NATIONAL_ID_PLACEHOLDER: "٢٤٢١١١١١١١١١١١١٢",
    OLD_MOBILE_NUMBER: "رقم الجوال القديم",
    NEW_MOBILE_NUMBER: "رقم الجوال الجديد",
    MOBILE_NUMBER_PLACEHOLDER: "٢٣٢٣٢٣٢٣٢",
    SUBMIT: "إرسال",
    PROCESSING: "جارٍ المعالجة...",
    CHANGE_MOBILE_SUCCESS: "تم تحديث رقم الجوال بنجاح!",
    SOMETHING_WENT_WRONG: "حدث خطأ ما!",
    NATIONAL_ID_REQUIRED: "رقم الهوية مطلوب",
    OLD_MOBILE_REQUIRED: "رقم الجوال القديم مطلوب",
    NEW_MOBILE_REQUIRED: "رقم الجوال الجديد مطلوب",
    INVALID_NATIONAL_ID: "يرجى إدخال رقم هوية مكون من 10 أرقام بشكل صحيح",
    INVALID_OLD_MOBILE: "يرجى إدخال رقم جوال قديم مكون من 9 أرقام بشكل صحيح",
    INVALID_NEW_MOBILE: "يرجى إدخال رقم جوال جديد مكون من 9 أرقام بشكل صحيح",
    MOBILE_SAME_ERROR: "يجب أن يكون رقم الجوال الجديد مختلفًا عن القديم",
    OTP_TITLE: "رمز التحقق",
    OTP_DESC: "تم إرسال رمز التحقق لمرة واحدة (OTP) عبر رسالة نصية قصيرة.",
    RESEND_CODE: "إعادة إرسال الرمز",
    CALL_SUPPORT: "اتصل للدعم:",
    EMAIL_SUPPORT: "راسلنا على:",
    INVALID_OTP: "الرجاء إدخال رمز تحقق صالح",
    OTP_VERIFIED: "تم التحقق من الرمز بنجاح!",
    OTP_RESENT: "تم إرسال رمز جديد!",
    SUBMIT: "إرسال",
    MOBILE_NUMBER_UPDATED: "تم تحديث رقم الجوال",
    SUCCESSFULLY: "بنجاح",
    VERIFYING: "جارٍ التحقق...",
    SENDING: "جارٍ الإرسال...",
  },
  SIGN_UP: {
    TITLE: "التسجيل",
    DESCRIPTION: "خطوة أقرب إلى الحلول المالية",
    FORM_DESCRIPTION: "من فضلك املأ النموذج التالي",
    HELP_LINE:
      "للمساعدة يرجي الاتصال بهذا الرقم: ٩٢٠٠٠٥٤٧٧ او ارسال ايميل الي : info@tamweel-aloula.com",
    DONE: "موافق",
    LABELS: {
      ID: "الهوية الوطنية / الإقامة",
      PHONE: "رقم الهاتف المسجل في أبشر",
      EMAIL: "بريد إلكتروني",
      CONFIRM_EMAIL: "تأكيد عنوان البريد الإلكتروني",
      PASSWORD: "كلمة المرور",
      CONFIRM_PASSWORD: "تأكيد كلمة المرور",
    },
    FIELDS: {
      ID: "الهوية",
      PHONE: "9665XXXXXXXX",
      EMAIL: "بريد إلكتروني",
      CONFIRM_EMAIL: "تأكيد عنوان البريد الإلكتروني",
      PASSWORD: "كلمة المرور",
      CONFIRM_PASSWORD: "تأكيد كلمة المرور",
      HIJRI_DATE: "تاريخ الميلاد بالهجرى",
      GEORGIAN_DATE: "تاريخ الميلاد بالميلادى",
      SELECT_DATE_TYPE: "أختر نوع التاريخ",
    },
    TERMS_AGREE: "لقد قرأت ووافقت على",
    TERMS_MODEL: {
      TITLE: "الشروط والأحكام",
      CONTENT: `
<div style="line-height: 1.8; white-space: pre-wrap;">
أقرّ أنا مقدم الطلب بأن جميع المستندات والبيانات والمعلومات المقدمة صحيحة وأصلية وسارية المفعول نظامًا. وأُقرّ بأن تقديم مستندات غير صحيحة و مزورة أو معدّلة أو مضللة يُعدّ احتيالًا، ويترتب عليه رفض الطلب، أو إلغاء أي خدمة تمت الموافقة عليها، أو المطالبة الفورية بسداد أي تمويل ممنوح، إضافةً إلى الإبلاغ للجهات المختصة واتخاذ الإجراءات القانونية وفقًا للأنظمة المعمول بها في المملكة العربية السعودية.

<strong>1.</strong> المستخدم: يعني العميل أو الشخص المفوض من العميل و المصرح له من قبل الشركة بالدخول لتقديم البيانات والمستندات على طلب المنتج.

<strong>2.</strong> تلتزم الشركة بتنفيذ كافة التعليمات والمعاملات الواردة من المُستخدم إلكترونياً بشرط أن تكون متوافقة مع نظام العمل في الشركة و تعليمات الجهات الرسمية المختصة والقوانين التمويلية وفقا لتقديرها المطلق.

<strong>3.</strong> هذه الخدمة تتم إلكترونياً باستخدام التصديق الرقمي ولا يجوز الطعن بتنفيذها إلكترونياً.

<strong>4.</strong> يحق للشركة تقييد أي عمليات ينفذها المُستخدم إلكترونيا على العقد ويلتزم العميل بدفع الرسوم التي تحددها الشركة مقابل الاستفادة من هذه الخدمة ، والتي قد يتم تعديلها من وقت لآخر وفقا لتقديرها المطلق.

<strong>5.</strong> أقر أنا مقدم الطلب عن المسؤولية الإلكترونية ، والمسؤولية الكاملة عن الشخص المفوض من قبلي لاستخدام الخدمات الإلكترونية وإجراء المعاملات الكاملة من خلال المستخدم والرقم السري وكل مايتعلق ومقتضيات المحافظة عليهما ، وعدم الإفصاح عن الرقم لأي جهة حتى موظف الشركة أو أي شخص آخر أو جهة أخرى.

<strong>6.</strong> أقر أنا مقدم الطلب بأن الشركة والجهات التابعة لها وموظفي الشركة غير مسؤولين عن أي خسائر أو أضرار أو مطالبة مالية أو خلافها ناتجة عن استعمال حساب المستخدم و الرقم السري الخاص بي ، وألتزم بإخطار الشركة فور حدوث ما يخالف ذلك بموجب خطاب موثق مني بالحادثة إذا تبين لي أن الرقم السري قد أصبح معلوما للآخرين حتى تتمكن الشركة من إجراء اللازم ، وأكون مسئولا عن جميع المعاملات والتعليمات الصادرة من حساب المستخدم لحين تسلم الشركة للبلاغ الخطي والحصول على إفادة خطية منها بذلك.

<strong>7.</strong> أقر أنا مقدم الطلب بالمحافظة الكاملة على سرية حساب المستخدم معلوماته ومعاملاته التمويلية ، وأكون مسئولا عن أي استعمال أو استخدام غير مرخص به ووتحمل كافة النتائج التي قد تترتب على ذلك سواء كانت مباشرة أو غير مباشرة.

<strong>8.</strong> أٌقر أنا مقدم الطلب بعدم ملكية الحقوق الفكرية لبرامج ومستندات الخدمات الإلكترونية المقدمة و أوافق على عدم السماح لي كمستخدم بنسخ أو تعديل البرامج أو خلافه أو تحميل أو نقل برامج الخدمات الإلكترونية إلى موقع إلكتروني مماثل.

<strong>9.</strong> أقر أنا مقدم الطلب بإمكانية الاطلاع على حالة الطلب ومعرفة الحالة (قبول أو رفض) من خلال هذه الخدمة.كما أقر بأن ليس على الشركة أي إلتزامات عند عدم قبول الطلب لإي سبب من الأسباب.

<strong>10.</strong> يحق لشركة تمويل الاولى اللجوء للجهات القضائية المعنية والمطالبة بالتعويض حيال أي ضرر أو مصاريف تمت بناء على دراسة طلب تمويل أو قبول طلب التمويل في حال تبيّن أن أيًا من المعلومات أو المستندات المقدمة غير صحيحة، أو مضللة، أو غير مكتملة، أو مزورة، أو معدّلة، أو مقدمة بقصد احتيالي، أو غير متوافقة مع الشروط والأحكام الداخلية للشركة أو المتطلبات النظامية للجهات ذات العلاقة.

<strong>11.</strong> أقر بالموافقة على تلقي كافة المراسلات و الإشعارات المتعلقة بالطلب المقدم من قبلي عن طريق البريد الإلكتروني والرسائل النصية والاتصال والالتزام باتخاذ كافة الاحتياطات اللازمة لسرية المراسلات ، وأكون مسؤول عن أي انتهاكات قد تنجم عن ذلك.

<strong>12.</strong> أقر بالموافقة على أحقية الشركة بتسجيل كافة الاتصالات والتعليمات الوارد عن طريق الخدمات الإلكترونية وأن تكون هذه التسجيلات الصوتية بينة على ما ورد فيها من معلومات في حال استخدام الرقم المجاني أو قسم خدمات العملاء.

<strong>13.</strong> أقرّ بأن مصادر الدخل والمستندات الداعمة المقدمة بغرض الحصول على التمويل هي مستندات مشروعة وصحيحة وغير خاضعة لأي تلاعب أو تعديل بأي شكل من الأشكال. ويُعدّ أي تحريف أو تزوير إخلالًا جوهريًا بهذه الشروط والأحكام وموجب للمساءلة القانونية كما أقر بموافقتي بأنه يحق لشركة تمويل الأولى الحصول على جميع المعلومات التي ترغب بالحصول عليها من مزود الخدمة شركة (سمة).

<strong>14.</strong> أقر أنا مقدم الطلب بأن أي تأخير ناجم من الشركة بالمطالبة عن أي حق أو صلاحية واردة لها في هذه الشروط لا يعد تنازلا عن هذا الحق أو الصلاحية ومن حق الشركة المُطالبة به في أي وقت تشاء.

<strong>15.</strong> أقر أنا مقدم الطلب بأن تحتفظ الشركة بحقها في تعديل هذه الشروط ، ويُعد الإستمرار في استعمال المستخدم من قبلي موافقة مني بذلك على التعديل.

<strong>16.</strong> يتم تنفيذ وتفسير هذه الشروط طبقاً لأحكام القوانين والأنظمة المعمول بها في المملكة العربية السعودية ، وكل ما لم يرد به نص يكون طبقاً للأنظمة السعودية ويتم حسم النزاعات المُتعلقة بهذه الخدمة أمام المحاكم السعودية المختصة.

<strong>17.</strong> كما يقر العميل " مقدم الطلب" خلال فترة تقديمه لطلب التمويل لدى شركة تمويل الأولى ولغاية حصوله على ذلك بعدم التقدم لدى أي جهة أخرى للحصول على تمويل أو أي التزام مالي مما قد يؤثر على سجله الائتماني ، كما يقر و يتعهد بالتزامه بالأنظمة والضوابط وتعليمات البنك المركزي السعودي وجميع الضوابط التشريعية الأخرى ، وفي حالة مخالفة ذلك فإنه يحق لشركة تمويل الأولى رفض منحه التمويل المطلوب ومقاضاة العميل " مقدم الطلب" لدى أي جهة رسمية ومطالبته بأي مبالغ أو رسوم أو تعويضات قد نتجت عن تقديمه لهذا الطلب . يُعتبر أي تحريف جوهري للحقائق، أو إخفاء لمعلومات، أو تقديم مستندات مزورة أو ملفقة، إخلالًا أساسيًا وجوهريًا بالعلاقة التعاقدية بين الطرفين، ويترتب عليه ما تراه الشركة مناسبًا من إجراءات نظامية وقانونية.

<strong>18.</strong> كما يقر ويتعهد العميل بتحمله كامل المسؤولية عن تقديمه طلب التمويل لدى شركة تمويل الأولى و بعد الحصول على الموافقة الائتمانية عند تقديم طلب التمويل و الموافقة عليه بالمنح لمنتج التمويل المقدم من قبله , كما يقر بمعرفته التامة لعواقب وتبعات تجاوز نسبة عبء الدين المسموح بها نظاما خلال فترة سريان عقد التمويل وعن كل ما ينجم عن مثل هذا التجاوز وإقراره أنه في حالة وقوعه لدى العميل وذلك من خلال تقدمه بطلبات تمويل لدى جهات تمويلية أخرى وحصوله تزامناً أو في أي وقت لاحق على قروض إضافية تزيد من اجمالي التزاماته عن الحد المسموح فإنه يتحمل كامل المسؤولية عن ما تقدم به ويعتبر إخلالا بالشروط التعاقدية مع شركة تمويل وبذلك يتحمل سداد كامل المبلغ المتفق عليه بالعقد، وتحتفظ الشركة بحقها بالمطالبة الفورية والسداد لكامل المبلغ

<strong>19.</strong> تحتفظ الشركة بحقها في الإبلاغ عن أي اشتباه في احتيال إلى الجهات المختصة في المملكة العربية السعودية، واتخاذ الإجراءات المدنية والجنائية وفقًا لما تسمح به الأنظمة واللوائح المعمول بها.

<strong>20.</strong> يحق للشركة تجميد أو إيقاف الوصول إلى الحساب الإلكتروني مؤقتًا في حال عدم نشاط الحساب، أو انتهاء صلاحية هوية العميل، أو تكرار محاولات الدخول الفاشلة. وسيتم إشعار العميل بالإجراء المتخذ وإبلاغه بالخطوات اللازمة لاستعادة الخدمة أو الاستمرار في استخدامها.

<strong>21.</strong> يحق للشركة حجب أو تقييد الوصول إلى الحساب الإلكتروني في حال الاشتباه بوجود نشاط احتيالي، أو تقديم معلومات مضللة، أو استخدام غير مصرح به. ويقر العميل بأن للشركة اتخاذ مثل هذه الإجراءات وفقًا لتقديرها المنفرد بهدف حماية أنظمتها وخدماتها.

<strong>22.</strong> تحتفظ الشركة بحقها في اتخاذ الإجراءات القانونية، بما في ذلك رفع دعاوى مدنية أو جنائية، في حال ثبوت ارتكاب العميل لأي احتيال، أو تقديم مستندات مزورة، أو ممارسة أي أساليب احتيالية أو تضليلية فيما يتعلق بالخدمات المقدمة. ويقر العميل بتحمله المسؤولية الكاملة عن أي أفعال احتيالية وما يترتب عليها من آثار قانونية ومالية.
</div>
    `,
      ACTION: "اوافق",
      ACCEPTED: "قبلت",
    },
    NATIONAL_INFORMATION_ACCEPTENCE:
      "السماح لشركة لتمويل الاولى باستخدام خدمات مركز المعلومات للتحقق من الهوية",
    NEWS_AND_OFFERS_CONSENT:
      "أود معرفة أحدث العروض والمستجدات المخصصة من تمويل الأولى",
    ALREADY_ACCOUNT: "هل لديك حساب؟",
    SIGN_IN: "تسجيل الدخول",
    FROM_BUTTON: "متابعة",
    PRIVACY: {
      TITLE: "إشعار الخصوصية",
      ACCEPT: "أوافق",
      DECLINE: "أرفض"
    },
  },
  COMPLAINTS: {
    TITLE: "المساعدة والدعم",
    COMPLAINT_SUBMISSION: "تقديم شكوى",
    COMPLAINT_DESC: "يرجى تعبئة النموذج أدناه لتقديم شكواك.",
    FIELDS: {
      FULL_NAME: "الاسم الكامل",
      ID: "رقم الهوية الوطنية / الإقامة",
      EMAIL: "البريد الإلكتروني",
      PHONE: "رقم الجوال",
      COMPLAINT_DETAILS: "تفاصيل الشكوى",
      CITY: "المدينة",
    },
    PLACEHOLDERS: {
      FULL_NAME: "مثال: احمد محمد",
      ID: "مثال: 25174XXXXX",
      EMAIL: "مثال: Name@mail.com",
      PHONE: "مثال: 96645555555",
      COMPLAINT_DETAILS: "يرجى وصف مشكلتك...",
      CITY: "مثال: الرياض",
    },
    VERIFY: "تحقق من رقم الجوال",
    VERIFY_DESC: "تم إرسال رمز التحقق (OTP) عبر الرسائل النصية",
    VALIDATE: "تأكيد رمز التحقق",
    SUBMIT: "تقديم الشكوى",
    PHONE_VERIFIED: "تم التحقق من رقم الجوال",
    TIMEOUT: "انتهت صلاحية رمز التحقق!",
    VALIDATION: {
      NAME_MAX_LENGTH: "يجب أن يكون الاسم أقل من 100 حرف",
      NAME_ONLY_LETTERS: "يجب أن يحتوي الاسم على أحرف فقط",
      NAME_REQUIRED: "الاسم مطلوب",
      PHONE_FORMAT: "يجب أن يكون رقم الهاتف بصيغة 9665XXXXXXXX",
      PHONE_REQUIRED: "رقم الهاتف مطلوب",
      EMAIL_FORMAT: "يجب أن يكون البريد الإلكتروني بصيغة Name@mail.com",
      EMAIL_MAX_LENGTH: "يجب أن يكون البريد الإلكتروني أقل من 55 حرف",
      EMAIL_REQUIRED: "البريد الإلكتروني مطلوب",
      DETAILS_MAX_LENGTH: "يجب أن تكون التفاصيل أقل من 4000 حرف",
      DETAILS_ALLOWED_CHARS:
        "يجب أن تحتوي التفاصيل على أحرف عربية أو إنجليزية، أرقام، مسافات، فواصل، ونقاط",
      DETAILS_REQUIRED: "التفاصيل مطلوبة",
      ID_FORMAT: "يجب أن يتكون رقم الهوية من 10 أرقام",
      ID_REQUIRED: "رقم الهوية مطلوب",
      ID_START_WITH: "يجب أن يبدأ رقم الهوية بـ 1 أو 2",
      CITY_MAX_LENGTH: "يجب أن تكون المدينة أقل من 100 حرف",
      CITY_ONLY_LETTERS: "يجب أن تحتوي المدينة على أحرف فقط",
    },
    SUBMITTED: "تم الإرسال!",
    SUCCESS_PARA1: "تم تقديم شكواك بنجاح.",
    SUCCESS_PARA2: "سنقوم بمراجعتها والرد عليك قريبًا.",
    BACK: "العودة إلى تسجيل الدخول",
  },
  HOME: {
    GREETINGS: "تحياتنا",
    LAST_LOGIN: "آخر تسجيل دخول",
    CREATE_NEW: "إنشاء طلب جديد",
    REQUEST: "حالة الطلب",
    APPL_NO: "الرقم المرجعي",
    PRODUCT: "المنتج",
    CONTRACT: "العقد",
    STATUS: "الحالة",
    VIEW: "عرض التطبيق",
    COMPLETE: "الطلب كامل",
    SEARCH: "ابحث عن الاسم والمبلغ وما إلى ذلك.",
    ARE_YOU_SURE: "هل أنت متأكد أنك تريد تسجيل الخروج؟",
    EMPLOYMENT_DETAILS: "تفاصيل الوظيفة",
    Hi: "هلا",
    DIGITAL_APP_ID: "رقم الطلب",
    CONTRACT_SIGNING: "توقيع العقد",
    VIEW_CONTRACT: "اظهار العقد",
    UPLOAD_DOCUMENT: "رفع مستند",
    APPLICATION_TIME_LINE: "خط الزمن للتطبيق",
    VIEW_OFFER: "إظهار العرض",
    NO_REQUESTS: "لا يوجد تطبيقات بعد",
    EXPLORE_SERVICES: "استكشف خدماتنا وقدم طلبك:",
    AUTO: " التمويل التأجيري للسيارات",
    PERSONAL: "التمويل الشخصي",
    MICRO: "التمويل متناهي الصغر",
    AUTO_DESC: "متوافق مع الشريعة الإسلامية وبهامش ربح تنافسي",
    MOTO_DESC: "متوافق مع الشريعة الإسلامية وبهامش ربح تنافسي",
    PERSONAL_DESC: "متوافق مع الشريعة الإسلامية وبهامش ربح تنافسي",
    PRODUCT_TITLE: "منتجات تمويل الأولى",
    MICRO_DESC: "متوافق مع الشريعة الإسلامية ومع هامش ربح تنافسي",
    SCHOOL_DENTAL_PRODUCTS_TITLE: "منتجات التأجير التمويلي والدراجات النارية",
    SCHOOL_PRODUCTS_TITLE: "منتجات التعليم",
    DENTAL_PRODUCTS_TITLE: "الرعاية الصحية",
    HEALTHCARE_TITLE: "الرعاية الصحية",
    MICRO_PRODUCTS_TITLE:
      "تمكين احتياجاتك من خلال حلول التمويل متناهي الصغر المرنة",
    MICRO_SUB: "تمويل الأولى للتمويل متناهي الصغر",
    CARDS_TITLE: "تمويل مشتريات عبر بطاقه رقمية",
    SCHOOL_BANNER_TITLE: "التمويل التعليمي",
    // SCHOOL_BANNER_TITLE: "قم بتقسيط دفعاتك التعليمية مع تمويل الأولى",
    SEE_MORE: "شاهد المزيد",
    SCHOOL_ALNUBALAA: "مؤسسة نبلاء الإدارية",
    SCHOOL_DIGITAL_AL_MUNSIYAH:
      "شركة الثقافة الرقمية ( مدارس الثقافة الرقمية - فرع المونسيه )",
    SCHOOL_DIGITAL_IRQAH:
      "شركة الثقافة الرقمية ( مدارس الثقافة الرقمية - فرع عرقة )",
    SCHOOL_MINNHA: "شركة منحة لتقنية المعلومات( منصة منحة للتعليم )",
    SCHOOL_INTERLUDE:
      "وكالة فقرة فاصلة للسفر و السياحة ( وكالة انترلود للتعليم )",
    SCHOOL_ACHET: "مركز مستشارك المتقدم للتدريب الصحي",
    SCHOOL_ADCCC: "مركز عيادات مستشارك المتقدم لطب الاسنان",
    SCHOOL_YASCHOOLS: "شركة يا سكولز لتقنية المعلومات",
    SCHOOL_ALHASA: "مدارس الكفاح - الأحساء",
    SCHOOL_KHOBAR: "مدارس الكفاح - الخبر",
    SCHOOL_RIYADH: "مدارس الكفاح - الرياض",
    SCHOOL_SADA_ABDA: "صدى الابداع الحديثة التعليمة",
    SCHOOL_AL_MASHAEL: "مدارس المشاعل الاهليه",
    SCHOOL_AL_MOSA: "شركة الرعاية النوعية للتعليم - شركة الموسى الطبية",
    SCHOOL_AL_MANA: "كلية محمد المانع للعلوم الطبية",
    DENTAL_BANNER_TITLE: "الرعاية الصحية مع تمويل الأولى",
    KENZEL_DENTAL: "عيادات كنزل لطب الأسنان",
    MOTO: "تمويل الدراجات النارية",
    FEATURE_PRODUCTS: "المنتجات المميزة",
    EDUCATIONAL_PRODUCTS_TITLE: "التعليم",
    FURNITURE_PRODUCTS_TITLE: "الأثاث",
    ELECTRONICS_PRODUCTS_TITLE: "الإلكترونيات",
    NO_FEATURED_PRODUCTS: "حاليًا لا توجد منتجات تحت هذا التصنيف",
    VIEW_ALL: "عرض الكل",
  },
  OTHER_SERVICES: {
    TITLE: "الخدمات الأخرى",
    VEHICLE_TITLE: "خدمات المركبات",
    SUBTITLE: "خدماتنا الرقمية تساعدك على إتمام طلباتك بكل سهولة.",
    PAGE_TITLE_LEAD: "الخدمات",
    PAGE_TITLE_HIGHLIGHT: "الأخرى",
    APPLY_NOW: "قدّم الآن",
    COMING_SOON_TITLE: "قريباً",
    COMING_SOON_DESC:
      "شيء مميز قادم قريباً. نعمل على تجهيز خدمات جديدة لخدمتك بشكل أفضل. عد قريباً للاطلاع على المستجدات.",
    CONTINUE: "متابعة",
    SELECT_APPLICATION: "الرجاء اختيار طلب واحد",
    APPLICATION_ID: "رقم الطلب",
    NEXT: "التالي",
    BACK: "رجوع",
    SUBMIT: "إرسال",
    REVIEW_RESTRUCTURE: "راجع وأكّد طلب إعادة الهيكلة",
    REVIEW_TOPUP: "راجع وأكّد طلب زيادة التمويل",
    REVIEW_EARLY_SETTLEMENT: "راجع وأكّد طلب السداد المبكر",
    REVIEW_CLEARANCE_LETTER: "خطاب الإبراء الخاص بك جاهز للتنزيل.",
    OUTSTANDING_AMOUNT: "المبلغ المستحق",
    REMAINING_TENURE: "المدة المتبقية",
    MONTHS_SUFFIX: "شهراً",
    PLEASE_SELECT_TENURE: "الرجاء اختيار المدة",
    TENURE_IN_MONTHS: "المدة (بالأشهر)",
    TENURE_PLACEHOLDER: "مثال: 6 أشهر",
    TOPUP_AMOUNT: "مبلغ الزيادة",
    EARLY_SETTLEMENT_AMOUNT: "مبلغ السداد المبكر",
    UPLOAD_DOCUMENT: "رفع مستند",
    UPLOAD_DOC_HINT: "(يُسمح بملفات PDF فقط، حتى 3 ميجابايت)",
    DOCUMENT: "مستند",
    UPLOAD: "رفع",
    SUBMIT_SUCCESS_TITLE: "تم إرسال الطلب بنجاح – تحقق من طلبك",
    SUBMIT_SUCCESS_MSG: "يرجى الرد على مكالمة التحقق (IVR) لمتابعة إرسال طلبك.",
    SERVICING_SUCCESS_TITLE: "تم إرسال الطلب بنجاح",
    SERVICING_SUCCESS_MSG:
      "تم استلام طلبك. ستقوم تمويل بمراجعته والتواصل معك بالنتيجة.",
    REVIEW_BUYOUT: "راجع وأكّد طلب شراء المديونية",
    BUYOUT_DEBT_TITLE: "يرجى إدخال معلومات المديونية للمتابعة",
    ENTITY_ORGANIZATION: "الجهة / المؤسسة",
    ENTITY_PLACEHOLDER: "أدخل اسم الجهة",
    AMOUNT: "المبلغ",
    OTHER_BANK_IBAN: "رقم الآيبان لدى البنك الآخر",
    OTHER_BANK_TENURE: "مدة التمويل لدى البنك الآخر (بالأشهر)",
    TENURE_MONTHS_PLACEHOLDER: "مثال: 24",
    IBAN_PLACEHOLDER: "مثال: SA12321",
    EXTRA_AMOUNT: "مبلغ إضافي",
    ENTER_IBAN: "أدخل رقم الآيبان",
    DEBT_PROOF_LETTER: "خطاب إثبات المديونية",
    REVIEW_PARTIAL_SETTLEMENT: "راجع وأكّد طلب السداد الجزئي",
    REPAYMENT_TYPE: "نوع السداد",
    REPAYMENT_TYPE_PLACEHOLDER: "اختر نوع السداد",
    REPAYMENT_PRINCIPAL_DECREASE: "تخفيض أصل التمويل",
    REPAYMENT_COMPRESSION: "ضغط الدفعات",
    RECALCULATION_METHOD: "إعادة الاحتساب حسب",
    RECALCULATION_PLACEHOLDER: "اختر طريقة إعادة الاحتساب",
    RECALC_TERM: "تقصير المدة",
    RECALC_INSTALLMENT: "تخفيض القسط",
    NO_OF_INSTALLMENTS: "عدد الأقساط",
    REVIEW_CANCELLATION: "راجع وأكّد طلب إلغاء التمويل",
    REVIEW_FINANCE_DETAILS: "راجع تفاصيل تمويلك",
    CANCELLATION_FEES: "رسوم إلغاء التمويل",
    CANCELLATION_NOT_AVAILABLE_IJARAH: "إلغاء التمويل غير متاح لمنتجات الإجارة.",
    SELECT_REGION: "الرجاء اختيار المنطقة",
    REGION_BAHRAIN: "البحرين",
    REGION_GCC: "دول الخليج",
    REGION_JORDAN: "الأردن",
    THREE_MONTH_AUTHORIZATION: "تفويض لمدة 3 أشهر",
    THREE_MONTH_INSURANCE: "تأمين لمدة 3 أشهر",
    ADHOC_SUCCESS_TITLE: "تم إرسال طلبك بنجاح.",
    ADHOC_SUCCESS_MSG:
      "عزيزنا العميل، تم إرسال رابط سداد إليك، يرجى التحقق من مدفوعات سداد وإتمام عملية الدفع.",
    DOCUMENT_PENDING_TITLE: "جارٍ تجهيز خطابك",
    DOCUMENT_PENDING_MSG:
      "لقد قمنا بطلب الخطاب. لم يصبح جاهزاً بعد — يرجى المحاولة مرة أخرى بعد قليل.",
    CHECK_AGAIN: "تحقق مرة أخرى",
    PDF_DOCUMENT: "ملف PDF",
    VIEW: "عرض",
    DOWNLOAD: "تنزيل",
    ERR_APPLICATION_NOT_FOUND: "لم نتمكن من العثور على هذا الطلب. يرجى اختيار طلب آخر.",
    ERR_APPLICATION_FORBIDDEN: "هذا الطلب غير متاح على حسابك.",
    ERR_OPERATION_IN_PROGRESS:
      "هناك طلب مماثل قيد المعالجة بالفعل. يرجى الانتظار قليلاً ثم المحاولة مرة أخرى.",
    ERR_RATE_LIMIT: "لقد أرسلت عدداً كبيراً من الطلبات. يرجى المحاولة لاحقاً.",
    ERR_REQUEST_FAILED: "تعذّر إرسال طلبك في الوقت الحالي. يرجى المحاولة مرة أخرى.",
  },
  CREATE_REQUEST: {
    OF: "من",
    STEPS: "خطوات",
    AUTO: "قرض السيارة",
    CANCEL: "إلغاء",
    CANCEL_REQUEST: "إلغاء الطلب؟",
    CONFIRM: "تأكيد",
    ARE_YOU_SURE_REQUEST: "هل أنت متأكد أنك تريد إلغاء الطلب؟",
    DOCUMENT: "وثيقة",
    CLICK_TO_UPLOAD: "انقر لتحميل الملف",
    EMPLOYMENT_DETAILS: "تفاصيل العمل",
    FINANCIAL_DETAILS: "التفاصيل المالية",
    NEXT: "التالي",
    SALES_REFERENCE: "مرجع المبيعات",
    DO_YOU_SALE_REFERENCE: "هل لديك مرجع مندوب المبيعات؟",
    EXACTLY_8_ALLOWED: "يُسمح بـ 8 أرقام فقط.",
    SALES_PERSON_REF: "مرجع مندوب المبيعات",
    LOAN_DETAILS: "تفاصيل التمويل",
    PERSONAL_DETAILS: "التفاصيل الشخصية",
    GREAT: "رائع!",
    YOUR_REQUEST: "تم إرسال طلبك",
    SUBMITTED_FOR_REVIEW: "للمراجعة.",
    THANKS_FOR_APPLYING: "شكرًا لتقديمك الطلب.",
    APP_NO: "رقم الطلب",
    FEEDBACK: "ساعدنا على التحسين وقيم تجربتك معنا!",
    THANKS_FOR_FEEDBACK: "شكرًا لملاحظاتك",
    WRITE_COMMENT: "اكتب تعليقك",
    ADD_COMMENT: "إضافة تعليق",
    COMMENT_SUB: "لا تتردد في إخبارنا عن تجربتك",
    ONLY_ONE_MINUTE: "سيستغرق هذا دقيقة واحدة فقط",
    DONE: "تم",
    WE_WILL_GET_BACK: "سنتواصل معك قريبًا.",
    KINDLY_MESSAGE: "يرجى الاتصال بفريق المبيعات.",
    FURTHER_ASSISTANCE: "920005477 للحصول على المساعدة.",
    Full_Name: "الاسم الكامل",
    // Address: "العنوان",
    Street_Name: "اسم الشارع",
    Street_Name_AR: "اسم الشارع (بالعربي)",
    Building_Num: "رقم المبنى",
    Additional_Num: "الرقم الإضافي",
    District_Name: "اسم الحي",
    Post_Code: "الرمز البريدي",
    ID_Expiry_Date: "تاريخ انتهاء الهوية",
    street_name_required: "اسم الشارع مطلوب",
    street_name_max_150: "لا يمكن أن يتجاوز اسم الشارع 150 حرفًا",
    street_name_ar_max_150: "لا يمكن أن يتجاوز اسم الشارع (بالعربي) 150 حرفًا",
    buildingnum_required: "رقم المبنى مطلوب",
    additional_name_required: "الرقم الإضافي مطلوب",
    District_name_required: "اسم الحي مطلوب",
    Post_code_required: "الرمز البريدي مطلوب",
    Post_code_only_number: "يجب أن يكون الرمز البريدي رقمًا",
    building_num_only_number: "يجب أن يكون رقم المبنى رقمًا",
    Post_code_six_digits: "يجب ألا يتجاوز الرمز البريدي 6 أرقام",
    Post_code_four_digits_min: "لا يمكن أن يكون الرمز البريدي أقل من 4 أرقام",
    ID: "الهوية",
    Region: "المنطقة",
    City: "المدينة",
    Marital_status: "الحالة الاجتماعية",
    Title: "اللقب",
    Number_of_dependents: "عدد المعالين",
    Nationality: "الجنسية",
    IBAN: "رقم الحساب البنكي الدولي (IBAN)",
    Gender: "الجنس",
    Employment_type: "نوع العمل",
    Education_Level: "المستوى التعليمي",
    Resident_Status: "حالة الإقامة",
    Employment_Sector: "قطاع العمل",
    Joining_Date: "تاريخ الانضمام",
    PEP_Relation:
      "هل أنت معرف سياسيا؟ أم لديك قرابة من الدرجة الأولى أو الثانية مع أحد المعرفين سياسيا؟",
    Real_Benificiary: "هل أنت المستفيد الحقيقي من التمويل؟",
    Real_Benificiary_Name: "اسم المستفيد الحقيقي",
    Related_Party:
      "هل تربطك صله قرابه من الدرجة الأولى مع احد أعضاء مجلس الإدارة, او أعضاء اللجان او كبار المدراء التنفيذين ؟",
    Party_Postion: "المنصب",
    pep_relation_required: "هذا الحقل مطلوب",
    PEP_TOOLTIP_TITLE: "الشخص المُعرَّف سياسيًا PEP",
    PEP_TOOLTIP_CONTENT:
      "هو شخص يشغل (أو شغل سابقًا) منصبًا عامًا بارزًا أو وظيفة حكومية رفيعة. وبسبب نفوذه وإمكانية وصوله إلى الأموال العامة، قد يُعتبر أكثر عرضة لمخاطر الفساد أو الرشوة أو غسل الأموال.\nأمثلة: الوزراء، أعضاء مجلس الشورى أو البرلمان، كبار التنفيذيين في الشركات المملوكة للدولة، الضباط العسكريون رفيعو الرتبة.",
    real_benificiary_required: "هذا الحقل مطلوب",
    related_party_required: "هذا الحقل مطلوب",
    party_position_required: "هذا الحقل مطلوب",
    Type_of_loan: "نوع التمويل",
    Facility: "المرفق",
    Requested_loan_amount: "المبلغ المطلوب القسط",
    SalesRef: "الرقم المرجعي للمبيعات (اختياري)",
    ReferenceID: "رقم الموظف / رمز الدعوة (اختياري)",
    Requested_loan_amount_: "المبلغ المطلوب",
    Tenure_: "فترة السداد (بالأشهر)",
    Tenure: "مدة القسط (بالأشهر)",
    Food_expenses: "نفقات الطعام",
    Housing_expenses: "نفقات السكن",
    Domestic_workers: "العمالة المنزلية",
    Education_expenses: "نفقات التعليم",
    Health_care_expenses: "نفقات الرعاية الصحية",
    Communication_and_transportation_expenses: "نفقات الاتصالات والنقل",
    Insurance_expenses: "نفقات التأمين",
    Any_expected_future_expenses: "أي نفقات مستقبلية متوقعة",
    Total_expenses: "إجمالي النفقات",
    Asset_manufacturer: "الشركة المصنعة للمركبة",
    Asset_model: "نموذج المركبة",
    Asset_model_type: "نوع نموذج المركبة",
    Asset_color: "لون المركبة",
    Asset_condition: "حالة المركبة",
    Asset_price: "سعر المركبة",
    Asset_model_year: "سنة نموذج المركبة",
    Chassis_number: "رقم الهيكل",
    Down_payment: "الدفعة المقدمة",
    Ballon_payment: "الدفعة الاخيرة",
    Dealer_name: "اسم التاجر",
    Document: "وثيقة",
    First_name: "الاسم الأول",
    Middle_name: "الاسم الأوسط",
    Family_name: "اسم العائلة",
    ID_type: "نوع الهوية",
    ID_number: "رقم الهوية",
    Phone: "الهاتف",
    Email: "البريد الإلكتروني",
    Select_Marital: "اختر حالتك الاجتماعية.",
    Pick_Dependents: "اختر عدد المعالين.",
    Only_Arabic: "فقط الأحرف العربية مسموح بها",
    ONLY_CHARACTERS_ALLOWED: "فقط الأحرف مسموح بها.",
    CANNOT_BE_EMPTY: "لا يمكن أن يكون فارغًا.",
    MAX_12_MONTHS: "يجب أن يكون أقل من أو يساوي 12 شهرًا",
    MAX_36_MONTHS: "يجب أن يكون أقل من أو يساوي 36 شهرًا",
    MAX_60_MONTHS: "يجب أن يكون أقل من أو يساوي 60 شهرًا",
    IBAN_22: "يجب أن يتكون رقم الآيبان من 22 حرف أو رقم.",
    IBAN_ALPHANUMERIC_ONLY: "يجب أن يحتوي رقم الآيبان على أحرف وأرقام فقط.",
    IBAN_ONLY_NUMBERS: "يجب أن يحتوي رقم الآيبان على أرقام فقط.",
    MUST_BE_INTEGER: "يجب أن يكون عدد صحيح.",
    MUST_BE_ATLEAST: "يجب أن يكون على الأقل 25,000",
    MUST_BE_ATLEAST_3000: "يجب أن يكون على الأقل 3000",
    MUST_BE_ATLEAST_20000: "يجب أن يكون على الأقل 20000",
    MUST_BE_ATLEAST_2500: "يجب أن يكون على الأقل 2500",
    MUST_BE_ATLEAST_2000: "يجب أن يكون على الأقل 2000",
    MUST_BE_ATLEAST_5000: "يجب أن يكون على الأقل 5000",
    MUST_BE_ATLEAST_3500: "يجب أن يكون على الأقل 3500",
    // Generic dynamic-range messages used by V2 vendor-driven product pages.
    MUST_BE_ATLEAST_AMOUNT: "المبلغ أقل من الحد الأدنى المسموح به لهذا البائع",
    CANNOT_EXCEED_AMOUNT: "المبلغ يتجاوز الحد الأقصى المسموح به لهذا البائع",
    MUST_BE_8_DIGITS: "يجب أن يحتوي على 8 أرقام.",
    MUST_BE_BETWEEN_8_AND_10_DIGITS: "يجب أن يكون بين 8 إلى 10 أرقام",
    CHASSIS_NUMBER_INVALID: "يجب أن يتكون من 17 حرفًا أو رقمًا كحد أقصى",
    CANNOT_EXCEED: "لا يمكن أن يتجاوز 7 أرقام",
    CANNOT_EXCEED_500000: "لا يمكن أن يتجاوز 500000",
    CANNOT_EXCEED_50000: "لا يمكن أن يتجاوز 50000",
    CANNOT_EXCEED_30000: " لا يمكن أن يتجاوز 30000",
    CANNOT_EXCEED_80000: "لا يمكن أن يتجاوز 80000",
    CANNOT_EXCEED_20000: "لا يمكن أن يتجاوز 20000",
    CANNOT_EXCEED_4: "لا يمكن أن يتجاوز 4 أرقام",
    MUST_BE_ATLEAST_0: "يجب أن يكون على الأقل 0",
    CANNOT_EXCEED_7: "لا يمكن أن يتجاوز 7 أرقام",
    CANNOT_EXCEED_50: "لا يمكن أن يتجاوز 50 حرفًا.",
    DOWN_PAYMENT_20:
      "يجب أن تكون الدفعة الأولى 3 آلاف أو أكثر ويجب أن تكون أقل من سعر الأصول",
    BALLON_PAYMENT_40: "يجب ألا تتجاوز دفعة البالون 40% من سعر الأصل",
    BALLON_REQUIRED: "دفعة البالون مطلوبة",
    DOWN_PAYMENT_REQUIRED: "مطلوب دفعة مقدمة",
    NAME_REQUIRED: "الاسم مطلوب.",
    PHONE_REQUIRED: "رقم الهاتف مطلوب.",
    LOADING_DETAILS: "تحميل التفاصيل الشخصية...",
    LOADING_ADDRESS_DETAILS: "جارٍ تحميل تفاصيل العنوان...",
    LOADING_MARITAL_DETAILS: "تحميل التفاصيل الزوجية...",
    LOADING_EMPLOYMENT_DETAILS: "جاري تحميل تفاصيل التوظيف...",
    LOADING_LOAN_DETAILS: "جاري تحميل تفاصيل التمويل...",
    LOADING_FINANCIAL_DETAILS: "جاري تحميل التفاصيل المالية...",
    LOADING_AUTOLOAN_DETAILS: "جاري تحميل تفاصيل قرض السيارة...",
    LOADING_DOCUMENT_DETAILS: "جاري تحميل تفاصيل المستند...",
    LOADING_ASSET_DETAILS: "تحميل تفاصيل الاصول",
    Male: "ذكر",
    Female: "أنثى",
    undefined: "",
    DOC_CONDITION_1: "يرجى ارفاق شهادة التعريف بالراتب",
    DOC_CONDITION_2: "يرجى ارفاق كشف الحساب لأخر ٣ شهور",
    DOC_CONDITION_3: "إذا كان مبلغ التمويل ٤٠،٠٠٠ ريال او أكثر.",
    MAX_FILES_UPLOADED: "تم تحميل الحد الأقصى لعدد الملفات",
    Occupation: "المسمى الوظيفي",
    LOAN_REASON: "سبب التقديم على الطلب",
    LOAN_REASON_REQUIRED: "سبب التقديم على الطلب مطلوب",
    MANAGE_OFFERS_DES:
      "أرغب في تلقي أحدث العروض والمستجدات المخصصة من تمويل الأولى",
    BANK_STATEMENT: "كشف حساب بنكي",
    PAY_SLIP: "كشف الراتب",
    OTHER_DOCUMENTS: "مستندات أخرى",
    SELECT_FILE: "اختر ملف",
    REMOVE: "إزالة",
    IVR_VERIFICATION_TITLE: "التحقق من طلبك",
    IVR_VERIFICATION_MESSAGE:
      "يرجى الرد على المكالمة الآلية التي ستتلقاها قريبًا للتحقق من طلبك وقبوله.",
    CONTINUE: "استمرار",
  },
  FORGOT_PASSWORD: {
    "Reset password": "اعادة ادخال كلمة المرور",
    "Forgot password?": "نسيت كلمة المرور؟",
    "Please, enter your phone": "فضلا، ادخل رقم الهاتف",
    Send: "ارسال",
    "Return to sign in": "الرجوع الي صفحة المرور",
    "Cannot be empty": "يجب ادخال رقم الهاتف",
    "Must be exactly 9 digits": "رقم الهاتف يحتوي علي ٩ ارقام",
    FORGOT_PASSWORD_LABEL: "رقم الهاتف المسجل في أبشر",
    ONE_TIME_OTP: "لقد أرسلنا كلمة المرور لمرة واحدة (OTP) عبر الرسائل النصية",
    ONE_TIME_PASS: "يرجى إدخال كلمة المرور الجديدة",
    RESET: "إعادة تعيين",
    PASSWORD: "كلمة المرور",
    CONFIRM_PASSWORD: "تأكيد كلمة المرور",
  },
  Marital_status: "الحالة الاجتماعية",
  Region: "المنطقة",
  Title: "اللقب",
  Nationality: "الجنسية",
  Number_of_dependents: "عدد المعالين",
  Male: "ذكر",
  Female: "أنثى",
  City: "مدينة",
  Employment_type: "نوع الوظيفة",
  Education_Level: "مستوى التعليم",
  Resident_Status: "حالة الإقامة",
  Occupation: "المسمى الوظيفي",
  Joining_Date: "تاريخ الانضمام",
  "Select date": "حدد تاريخ",
  "No Data": "لايوجد بيانات",
  "For Private Sector": "للقطاع الخاص",
  APPLICATION_ALREADY_EXISTS: "لديك تطبيق موجود بالفعل",
  ACTIVE_APPLICATION: "لديك طلب تمويل نشط بالفعل.",
  APPLICATION_ALREADY_SUBMITTED: "تم تقديم طلبك بالفعل",
  OFFER_PENDING_GENERATION: "العرض قيد الإعداد",
  CONTRACT_PENDING_GENERATION: "العقد قيد الإعداد",
  "Something went wrong": "هناك خطأ ما",
  PRODUCT_NAME: "أسم المنتج",
  ACTIONS: "الإجراءات",
  DELETE: "حذف",
  REFRESH: "اعاده تجميل",
  VIEW_CONTRACT: "شاهد العقد",
  USER_ALREADY_EXISTS: "لديك حساب بالفعل، يرجى تسجيل الدخول",
  DEVICE_ALREADY_REGISTERED: "الرجاء استخدام الجهاز الخاص بك لتسجيل حساب جديد",
  OFFER: {
    Offering: "عرض",
    Product: "منتج",
    KASTLENO: "رقم التطبيق",
    CUSTOMERNAME: "اسم العميل",
    ERRORLOADING: "خطأ في تحميل العرض",
    NO_DATA_ALLOWED_ERR: "لم يتم العثور على بيانات لهذا القسم.",
  },
  OFFER_TABLE: {
    APP_NO: "رقم الطلب",
    PRODUCT_NAME: "اسم المنتج",
    CONTRACT: "العقد",
    STATUS: "الحالة",
    OFFER: "عرض",
    REFRESH: "تحديث",
    DELETE: "حذف",
    VIEW_CONTRACT: "عرض العقد",
    EDIT: "تعديل",

    CONFIRM: "تأكيد؟",
    CONFIRM_BTN: "تأكيد",
    CANCEL: "تاكيد الرفض",
    CANCEL_BTN: "الرفض",
    CONFIRM_ACCEPTANCE: "تأكيد قبول العرض؟",
    CONFIRM_REJECTION: "رفض العرض المقدم؟",
    ACCEPT: "قبول",
  },
  CONTRACT: {
    CONTRACT: "العقد",
    CONTRACT_ACCEPT: "تم قبول العقد",
    CONTRACT_REJECT: "تم رفض العقد",
    CONTRACT_ACCEPTANCE: "هل تؤكد قبول العقد؟",
    CONTRACT_ERROR: "تعذر قبول العقد، يرجى المحاولة مرة أخرى",
    CONTRACT_ERROR_REJECT: "تعذر رفض العقد، يرجى المحاولة مرة أخرى",
    CONFIRM: "تأكيد",
    CONFIRM_QUESTION: "تأكيد؟",
    REJECT_QUESTION: "رفض العقد؟",
    CONFIRM_REJECTANCE: "هل تؤكد رفض العقد؟",
    REJECT: "رفض",
  },
  PRODUCTS: {
    AUTO_DESC_SUB:
      "يتيح لك التاجير التمويلي للسيارات امتلاك سيارة جديدة أو مستعملة من خلال شراكاتنا مع العديد من صالات العرض والوكالات بأقساط مرنة. يمكن للسعوديين والمقيمين في المملكة العربية السعودية التقدم بطلب للحصول على هذا الحل حيث يمكنهم الحصول على السيارة التي يختارونها من خلال القنوات الرقمية أو عن طريق زيارة أحد فروعنا.",
    MOTO_DESC_SUB:
      "يتيح لك التاجير التمويلي للسيارات امتلاك سيارة جديدة أو مستعملة من خلال شراكاتنا مع العديد من صالات العرض والوكالات بأقساط مرنة. يمكن للسعوديين والمقيمين في المملكة العربية السعودية التقدم بطلب للحصول على هذا الحل حيث يمكنهم الحصول على السيارة التي يختارونها من خلال القنوات الرقمية أو عن طريق زيارة أحد فروعنا.",
    PERSONAL_DESC_SUB:
      "نسعى في شركة تمويل الأولى لتقديم حلول تمويلية سهلة تمكن الجميع من الحصول على التمويل بسرعة. يمكنكم الآن تقديم طلب تمويل شخصي متوافق مع الشريعة الإسلامية عبر التقديم الرقمي.",
    SCHOOL_DESC_SUB:
      "سهّل دفع رسوم المدارس — قدّم الآن وقسّط المبلغ على دفعات شهرية ميسّرة عبر تمويل الأولى",
    DENTAL_DESC_SUB:
      "عيادات كنزل لطب الأسنان يقدم الدقة والجمال من خلال تقنية CAD/CAM المتقدمة والمواد الفاخرة. من الزراعات إلى الأطراف الاصطناعية، نضمن راحة دائمة وجودة عالمية. مثالي للعيادات السنية والطلاب والموزعين في جميع أنحاء العالم.",
    REQUESTED_AMOUNT_NOTICE_TITLE: "المبلغ المطلوب",
    REQUESTED_AMOUNT_NOTICE_TEXT:
      "عزيزي العميل، يرجى العلم بأن المبلغ المطلوب يتم تحويله إلى التاجر.",
    MICRO_DESC_SUB:
      "في شركة تمويل الأولى، نسعى لتقديم حلول تمويل سهلة تمكّن الجميع من الحصول على التمويل بسرعة. يمكنك الآن التقدم للحصول على منتج تمويل سيارات متوافق مع الشريعة الإسلامية عبر تقديم إلكتروني.",
    AUTO_PT1: "يشمل الموظفين والمتقاعدين.",
    AUTO_PT2: "يجب أن يكون عمر مقدم الطلب بين 21 و 60 سنة",
    AUTO_PT3: "الحد الأدنى للراتب 3500 ريال.",
    AUTO_PT4:
      "الحد الأدنى للتمويل لا يقل عن 20,000 ريال، والحد الأقصى للتمويل هو 500,000 ريال.",
    AUTO_PT5:
      "مدة الخدمة لا تقل عن 4 أشهر للقطاع الخاص ولا تقل عن 3 أشهر للقطاع شبه الحكومي ولا تقل عن شهر واحد للقطاع الحكومي.",
    AUTO_PT6:
      "يتراوح معدل النسبة السنوي بين 10% - 16% (التأمين غير مشمول) ويختلف وفقاً لمبلغ التمويل وفترة السداد.",
    AUTO_PT7: "تتراوح فترة السداد من 6 أشهر إلى 60 شهراً.",
    DENTAL_PT7: "مدة التمويل من 6 أشهر الى 18 شهر",
    AUTO_PT8: "نسبة الاستقطاع من الراتب تصل إلى 45%.",

    PRSNL_PT1: "يشمل الموظفين والمتقاعدين السعوديين.",
    PRSNL_PT2: "يجب أن يكون عمر مقدم الطلب بين 21 و 60 سنة.",
    PRSNL_PT3: "الحد الأدنى للراتب 4100 ريال.",
    PRSNL_PT4:
      "الحد الأدنى للتمويل هو 20,000 ريال للسعوديين و5,000 ريال لغير السعوديين، والحد الأقصى للتمويل هو 500,000 ريال للسعوديين و80,000 ريال لغير السعوديين.",
    PRSNL_PT5:
      "مدة الخدمة لا تقل عن 4 أشهر للقطاع الخاص ولا تقل عن 3 أشهر للقطاع شبه الحكومي ولا تقل عن شهر واحد للقطاع الحكومي.",
    PRSNL_PT6:
      "يتراوح معدل النسبة السنوي بين 20% - 39% ويختلف وفقاً لمبلغ التمويل وفترة السداد.",
    PRSNL_PT7: "تتراوح فترة السداد من 6 أشهر إلى 60 شهراً.",
    MICRO_PT1: "يشمل الموظفين والمتقاعدين السعوديين.",
    MICRO_PT2: "يجب أن يكون عمر مقدم الطلب بين 20 و 60 سنة.",
    MICRO_PT3: "الحد الأدنى للراتب هو 3500 ريال.",
    MICRO_PT4: "يجب ألا يقل مبلغ التمويل عن 5000 ريال، ولا يزيد عن 20000 ريال.",
    MICRO_PT5: "تتراوح فترة السداد بين 6 و 12 و 18 شهرًا وحتى 24 شهرًا.",
  },
  EDUCATIONAL: {
    SCHOOL_DESC_SUB:
      "قم بتقسيط دفعاتك التعليمية مع تمويل الأولى , متوافق مع الشريعة الإسلامية وبهامش ربح تنافس",
    AUTO_PT1: "يشمل الموظفين والمتقاعدين.",
    AUTO_PT2: "يجب أن يكون عمر مقدم الطلب بين 20 و 60 سنة",
    AUTO_PT3: "الحد الأدنى للراتب 3690 ريال.",
    AUTO_PT4:
      "الحد الأدنى للتمويل لا يقل عن 3,000 ريال، والحد الأقصى للتمويل هو 500,000 ريال.",
    //added point 4 again because they have different minimum limit for the educational and kenzel products
    AUTO_PT4_KENZEL:
      "الحد الأدنى للتمويل لا يقل عن 3,500 ريال، والحد الأقصى للتمويل هو 500,000 ريال.",
    AUTO_PT5:
      "مدة الخدمة لا تقل عن 3 أشهر للقطاع الخاص ولا تقل عن 1 أشهر للقطاع شبه الحكومي ولا تقل عن شهر واحد للقطاع الحكومي.",
    AUTO_PT6: "نسبة التحمل للعميل: %0",
    AUTO_PT7: "مدة التمويل من 6 أشهر إلى 10 أشهر.",
    AUTO_PT8:
      "يجب ألا يتجاوز القسط الشهري 45% من إجمالي الالتزامات الشهرية للعميل (DBR) / 65% إذا كان العميل لديه رهن عقاري.",
  },
  REQUEST_DETAILS: {
    DETAILS: "تفاصيل الطلب",
    REQUEST_NUMBER: "رقم الطلب",
    CUSTOMERNAME: "الاسم الكامل",
    EMAIL: "البريد الإلكتروني",
    IDNUMBER: "رقم الإقامة",
    DATE_OF_EXPIRY: "تاريخ الانتهاء",
    IBAN: "رقم الحساب البنكي",
    GENDER: "الجنس",
    MOBILE: "رقم الجوال",
    FOOD_EXPENSES: "نفقات الطعام",
    HOUSING_EXPENSES: "نفقات السكن",
    DOMESTIC_WORKERS: "العاملين المنزليين",
    EDUCATION_EXPENSES: "نفقات التعليم",
    HEALTHCARE_EXPENSES: "نفقات الرعاية الصحية",
    COMM_TRANS_EXPENSES: "نفقات الاتصالات والنقل",
    INSURANCE_EXPENSES: "نفقات التأمين",
    FUTURE_EXPENSES: "أية نفقات مستقبلية متوقعة",
    EMPCATID: "نوع التوظيف",
    SECTORID: "قطاع التوظيف",
    DATEOFJOINING: "تاريخ الانضمام",
    QUALIFICATIONID: "المستوى التعليمي",
    RESIDENTID: "حالة الإقامة",
    PRODUCTID: "نوع التمويل",
    SUBPRODUCTID: "المنشأة",
    REQUESTED_AMOUNT: "المبلغ المطلوب",
    TENURE: "المدة (بالأشهر)",
    ASSET_MANUFACTURER: "الشركة المصنعة للأصل",
    ASSET_MODEL: "نموذج الأصل",
    ASSET_MODEL_TYPE: "نوع نموذج الأصل",
    COLORID: "لون الأصل",
    ASSET_CONDITION: "حالة الأصل",
    ASSET_PRICE: "سعر الأصل",
    ASSET_MODEL_YEAR: "سنة نموذج الأصل",
    DOWN_PAYMENT: "الدفعة المقدمة",
    BALLOON_PAYMENT: "الدفعة الاخيرة",
    DEALERID: "اسم التاجر",
  },
  VIEW_OFFER: {
    FINANCE_AMOUNT: "مبلغ التمويل",
    DOWN_PAYMENT: "الدفعة المقدمة",
    BALLOON_PAYMENT: "الدفعة الاخيرة",
    EMI: "الأقساط الشهرية",
    AGREEMENT_TOTAL: "إجمالي التمويل",
    TENURE: "مدة العقد",
    NO_DATA_FOUND: "لم يتم العثور على بيانات لهذا الجزء.",
    APR: "معدل الفائدة السنوي",
  },
  LOADING: "تحميل ...",
  SETTINGS: {
    READ_MORE: "اقرأ المزيد",
    USER_PROFILE: "ملف تعريفي للمستخدم",
    Full_Name: "الاسم الكامل",
    Address: "العنوان",
    Birth_Date: "تاريخ الميلاد",
    Mobile_Number: "رقم الجوال",
    RESET_PASSWORD: "إعادة تعيين كلمة المرور",
    SUBMIT: "يُقدِّم",
    OLD_PASSWORD: "كلمة المرور القديمة",
    PLEASE_ENTER_OLD_PASSWORD: "الرجاء إدخال كلمة المرور القديمة",
    NEW_PASSWORD: "كلمة المرور الجديدة",
    PLEASE_ENTER_NEW_PASSWORD: "الرجاء إدخال كلمة المرور الجديدة",
    PASSWORDS_MUST_MATCH: "يجب أن تتطابق كلمات المرور",
    PLEASE_CONFIRM_PASSWORD: "الرجاء إدخال تأكيد كلمة المرور",
    CONFIRM_PASSWORD: "تأكيد كلمة المرور",
    WE_HAVE_SENT: "لقد أرسلنا كلمة المرور المؤقتة (OTP) عبر الرسائل القصيرة",
    ENTER_OTP: "يدخل OTP",
    SUBMIT_OTP: "يقدم OTP",
    //new setting design text
    REPAYMENT: "السداد",
    SETTINGS: "إعدادات",
    PERSONAL_DATA: "البيانات الشخصية",
    PERSONAL_DATA_DES: "إدارة اسمك ورقم هويتك...إلخ",
    ADDRESS_DETAILS: "تفاصيل العنوان",
    ADDRESS_DETAILS_DES: "إدارة مكان إقامتك",
    MARITAL_STATUS: "الحالة الاجتماعية",
    MARITAL_STATUS_DES: "إدارة حالتك الاجتماعية ورقم المعالين",
    ELIGIBILITY: "الأهلية",
    ELIGIBILITY_DES: "إدارة التوظيف وتفاصيل الدفع الخاصة بك",
    DOCUMENT: "وثيقة",
    DOCUMENT_DES: "عرض كافة المستندات الخاصة بك",
    DOCUMENT_DES_V2: "(فقط ملفات PDF مسموح بها، بحد أقصى 3 ميغابايت)",
    TERMS_AND_CONDITION: "الشروط والأحكام",
    TERMS_AND_CONDITION_DES: "قم بالاطلاع على شروط وأحكام تمويل",
    MANAGE_OFFERS: "إدارة العروض",
    MANAGE_OFFERS_DES: "إدارة العروض والاشتراكات",
    INSTALLMENT_DASHBOARD: "لوحة تحكم الأقساط",
    INSTALLMENT_DASHBOARD_DES: "إدارة تفاصيل الأقساط الخاصة بك",
    CONTACT_US: "تواصل معنا",
    CONTACT_US_DES:
      "سنجيب على أسئلتك ومشاكلك على مدار الساعة طوال أيام الأسبوع",
    NO_SIGNED_APPLICATIONS_FOUND: "لم يتم العثور على طلبات موقعة",
    SELECT_ONE_APPLICATION: "الرجاء اختيار طلب واحد",
    APPLICATION_ID: "رقم الطلب",
    NO_APPLICATION_FOUND_TITLE: "لا يوجد طلب",
    NO_APPLICATION_FOUND_DESC:
      "لا توجد طلبات متاحة في الوقت الحالي. ابدأ طلبًا جديدًا لعرضه هنا.",
    FAQ: "التعليمات",
    FAQ_DES: "إدارة حالتك الاجتماعية وعدد المعالين.",
    HELP_AND_SUPPORT: "المساعدة والدعم",
    HELP_AND_SUPPORT_DES: "عرض جهات اتصال تمويل",
    ADDRESS_DETAIL: "تفاصيل العنوان",
    SAVE: "حفظ",
    HIJRI_DOB: "تاريخ الميلاد بالهجرى",
    GEORGIAN_DOB: "تاريخ الميلاد بالميلادى",
    GENERAL_INFO: "معلومات عامة",
    CUSTOMER_DETAIL: "تفاصيل العميل",
    CONTACT_US: "تواصل معنا",
    CONTACT_DES: "سنجيب على أسئلتك ومشاكلك على مدار الساعة طوال أيام الأسبوع",
    CONTACT_CARD1: "الرقم الموحد للمبيعات",
    CONTACT_CARD2: "مركز رعاية العملاء",
    CONTACT_CARD3: "للاستفسار عن خدمات ما بعد البيع والشكاوى",
    VIEW: "عرض المستند",
    CHANGE_PASSWORD: "تغيير كلمة المرور",
    CHANGE_PASSWORD_DES: "إدارة كلمة المرور الخاصة بك",
    LOADING_DOCUMENT: "تحميل المستند",
    NO_DOCUMENTS_AVAILABLE: "لا توجد مستندات متاحة",
    DOCUMENTS_DRAG_DROP_HEADING: "انقر للتحميل أو اسحب وأفلت",
    DOCUMENTS_DRAG_DROP_TEXT:
      "(يمكن للعميل تحميل المستندات ذات الصلة عند الطلب، ويمكن تحميل الملفات بصيغة PDF و .Jpeg و .PNG فقط. يجب أن يكون الحجم ضمن 3 ميجابايت.)",
    ERROR_FILE_TYPE: "يمكنك تحميل ملفات JPG/PNG/PDF فقط!",
    ERROR_FILE_SIZE_3MB: "يجب أن يكون حجم الملف أقل من 3 ميجابايت!",
    ERROR_FILE_MULTIPLE_EXT:
      "الملفات ذات الامتدادات المتعددة غير مسموح بها. يرجى إعادة تسمية الملف.",
    ERROR_FILE_NAME_CONTRACT: "يجب أن لا يحتوي اسم الملف على كلمة 'عقد'",
    ERROR_DUPLICATE_FILE_NAME:
      "ملف بنفس الاسم موجود بالفعل. الرجاء إعادة تسمية الملف أو اختيار ملف آخر.",
    FILE_UPLOAD_SUCCESS: "تم رفع الملف بنجاح",
    FILE_UPLOAD_ERROR: "فشل في رفع الملف.",
    ERROR_NO_FILE_ADDED: "لم يتم إضافة ملف",
    BACK: "العودة",
    ALL_RIGHTS_RESERVED: "جميع الحقوق محفوظة",
    INSTLMNT_DASHBOADRD_SUMMARY: "ملخص لوحة التحكم",
    INSTALLMENT_DATA_UNAVAILABLE: "بيانات القسط غير متوفرة",
    INSTALLMENT_DATA_UNAVAILABLE_DESC:
      "لا توجد بيانات متاحة لعرض تفاصيل القسط. يرجى التحقق من حالة طلبك أو الاتصال بخدمة العملاء للحصول على المساعدة.",
    CHECK_BACK_LATER: "تحقق مرة أخرى لاحقًا",
    INSTALLMENT_NUMBER: "رقم القسط",
    INSTALLMENT_AMOUNT: "المبلغ",
    INSTALLMENT_DUE_DATE: "تاريخ استحقاق القسط",
    INSTALLMENT_STATUS: "حالة القسط",
    //Changed this to repayment schedule
    // INSTALLMENT_DETAILS: "تفاصيل القسط",
    REPAYMENT_SCHEDULE: "جدول السداد",
    BACK_TO_HOME: "العودة إلى الصفحة الرئيسية",
    CONTRACT_AMOUNT: "مبلغ العقد",
    REMAINING_AMOUNT: "المبلغ المتبقي",
    PAID_AMOUNT: "المبلغ المدفوع",
    NEXT_PAYMENT_DUE: "الدفعة المستحقة التالية",
    REPAYMENT_STATUS: "حالة السداد",
    NEXT_PAYMENT_DATE: "تاريخ الدفعة التالية",
    PAID: "مدفوع",
    UPCOMING: "قادمة",
    REMAINING: "متبقي",
    REPAYMENT_PROGRESS: "تقدّم السداد",
    SALARY_INFO: "معلومات الراتب",
    SALARY_INFO_DES: "تحديث أو تعديل الراتب",
    CURRENT_SALARY: "الراتب الحالي",
    CURRENT_SALARY_PLACEHOLDER: "الرجاء إدخال راتبك الحالي",
    EDIT_SALARY: "تعديل الراتب",
    UPDATE_SALARY: "تحديث الراتب",
    SALARY_UPDATE_SUCCESS: "تم تحديث الراتب بنجاح",
    SALARY_UPDATE_FAILED: "تعذّر تحديث الراتب، يرجى المحاولة مرة أخرى",
    SALARY_LOAD_FAILED: "تعذّر تحميل الراتب، يرجى المحاولة مرة أخرى",
    SALARY_REQUIRED: "الرجاء إدخال راتبك",
    SALARY_OUT_OF_RANGE: "يجب أن يكون الراتب بين 2,800 و 100,000",
    SALARY_LOCKED: "يمكنك تغيير راتبك مرة واحدة فقط كل 30 يومًا.",
    SALARY_NEXT_UPDATE: "يمكنك تحديثه مرة أخرى في",
  },
  SALARY_ELIGIBILITY: {
    TITLE: "معلومات الراتب الشهري",
    DESC: "الرجاء إدخال راتبك الشهري للتحقق من أهليتك قبل متابعة طلبك.",
    CURRENT_SALARY: "الراتب الحالي",
    SALARY_PLACEHOLDER: "الرجاء إدخال راتبك الحالي",
    PROCEED: "متابعة",
    SALARY_REQUIRED: "الرجاء إدخال راتبك الشهري",
    SALARY_OUT_OF_RANGE: "يجب أن يكون الراتب بين 2,800 و 100,000",
    CHECK_FAILED: "تعذّر التحقق من الأهلية، يرجى المحاولة مرة أخرى",
    NOT_ELIGIBLE_TITLE: "غير مؤهل للتقديم على هذا المنتج",
    NOT_ELIGIBLE_DESC: "دخلك الشهري أقل من الحد الأدنى المطلوب للراتب.",
    NOT_ELIGIBLE_ALT_PREFIX:
      "راتبك أقل من الحد الأدنى المطلوب. ومع ذلك، أنت مؤهل لـ",
    CONTINUE: "متابعة",
    AND: "و",
    PRODUCT_TWQ: "التمويل الشخصي",
    PRODUCT_MICRO: "التمويل متناهي الصغر",
    PRODUCT_IJARAH: "الإجارة",
    PRODUCT_MUR: "المرابحة",
  },
  VALIDATION: {
    AGE_REQUIREMENT: "يجب أن تكون على الأقل 18 عامًا",
    CANNOT_BE_EMPTY: "لا يمكن أن يكون فارغًا",
    INCORRECT_LENGTH: " يجب ان تكون الهوية ١٠ ارقام .",
    MUST_BE_CHECKED: "يجب أن يتم التحقق.",
    ID_STARTS_1_OR_2: "يجب أن يبدأ رقم الهوية بـ 1 أو 2.",
    EMAILS_DO_NOT_MATCH: "البريد الإلكتروني لا يتطابق.",
    PASSWORDS_DO_NOT_MATCH: "كلمات المرور لا تتطابق.",
    PASSWORD_REQUIREMENTS:
      "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل، وتحتوي على حرفين أبجديين؛ أحدهما كبير والآخر صغير، ورقم واحد، وحرف خاص واحد.",
    INVALID_EMAIL_ADDRESS: "عنوان البريد الإلكتروني غير صالح.",
    INVALID_PHONE_NUMBER: "رقم الهاتف غير صالح.",
    PHONE_MUST_START_WITH_966: "يجب أن يبدأ رقم الهاتف بـ 966.",
    FILL_REQUIRED_FIELDS: "يرجى ملء جميع الحقول المطلوبة.",
    IBAN_VAL_FAILED: "فشل التحقق من الـ IBAN. يرجى إدخال الـ IBAN الصحيح.",
    IBAN_VAL_SUCCESS: "تم التحقق من الـ IBAN بنجاح",
  },
  INPUTS: {
    DAY: "يوم",
    MONTH: "شهر",
    YEAR: "سنة",
  },
  MONTHS: {
    JANUARY: "يناير",
    FEBRUARY: "فبراير",
    MARCH: "مارس",
    APRIL: "أبريل",
    MAY: "مايو",
    JUNE: "يونيو",
    JULY: "يوليو",
    AUGUST: "أغسطس",
    SEPTEMBER: "سبتمبر",
    OCTOBER: "أكتوبر",
    NOVEMBER: "نوفمبر",
    DECEMBER: "ديسمبر",
  },
  AND: "و",

  privacy_note: {
    title_1: "اشعار الخصوصية",
    title: "ملاحظة الخصوصية",
    content:
      "شركة تمويل الأولى هي شركة مساهمة مغلقة مرخصة وخاضعة لإشراف ورقابة البنك المركزي السعودي سجل تجاري رقم 2050055043. نعمل في شركة تمويل الأولى على توفير تجربة رقمية متميزة تُسهل عملية الحصول على الحلول التمويلية للأفراد والشركات.\n" +
      'تمويل الأولى (المشار إليها فيما يلي بـ "نحن" أو "تمويل الأولى" أو "المؤسسة" تحترم حقك في خصوصية البيانات. في هذا الإشعار، تشير كلمة "أنت" إلى صاحب البيانات الذي تتم معالجة بياناته الشخصية بواسطة تمويل الأولى.\n' +
      "يوفر إشعار الخصوصية هذا معلومات حول كيفية تعامل شركة تمويل الأولى مع المعلومات الشخصية الخاصة بك ويصف الحقوق التي قد تكون لديك فيما يتعلق بمعلوماتك الشخصية. ينطبق هذا الإشعار على شركة تمويل الأولى وجمعها للمعلومات الشخصية واستخدامها والكشف عنها عبر الإنترنت وغيره.\n" +
      "تلتزم شركة تمويل الأولى بالحفاظ على سرية وخصوصية بيانات ومعلومات المستخدم.\n" +
      "لا يجوز لشركة تمويل الأولى جمع أو معالجة أو الكشف عن أي بيانات أو معلومات شخصية إلا وفقًا للضوابط المحددة المنصوص عليها في التعليمات التي تحكم سرية المعلومات الصادرة عن الجهات التنظيمية في المملكة مثل نظام قانون حماية البيانات الشخصية PDPL و المكتب الوطني لإدارة البيانات NDMO، والبنك المركزي السعودي  SAMA بما في ذلك جميع التعديلات المطبقة عليها من وقت لآخر.\n",
  },
  personal_data_collection_processing_disclosures: {
    title: "جمع ومعالجة وكشف البيانات الشخصية",
    collection: {
      title: "متى تقوم تمويل الأولى بجمع المعلومات الشخصية عنك",
      content:
        "يتم جمع هذه البيانات عندما تستخدم خدماتنا من خلال القنوات عبر الإنترنت وغيره",
    },
    types: {
      title:
        " ما هي أنواع المعلومات الشخصية التي تجمعها تمويل الأولى وتحتفظ بها",
      content_1:
        "عندما تتعامل مع تمويل الأولى، قد نقوم بجمع بيانات للمساعدة في التعرف عليك والاتصال بك، بما في ذلك، على سبيل المثال لا الحصر، اسمك وعنوان بريدك الإلكتروني وعنوانك الفعلي ورقم هاتفك (الخط الأرضي و/أو المحمول) ورقم الهوية.",
      content_2:
        "إذا قمت بإنشاء حساب، فقد نقوم بجمع اسم المستخدم وكلمة المرور وتاريخ الميلاد ومعلومات الهوية الوطنية لتزويدك بخدماتنا.\nإذا قمت بإنشاء حساب، فقد نقوم بجمع اسم المستخدم وكلمة المرور وتاريخ الميلاد ومعلومات الهوية الوطنية لتزويدك بخدماتنا.",
      content_3:
        "قد نقوم أيضًا بجمع بيانات حول الجهاز الذي تستخدمه للوصول إلى خدماتنا عبر الإنترنت. يتضمن ذلك معرف الجهاز ومعرف الإعلان وتفاصيل المتصفح أثناء استخدام خدماتنا عبر الإنترنت.",
      content_4:
        "\tقد نقوم بجمع معرف الجهاز IP الخاص بك والبيانات المتعلقة بعنوان IP هذا، مثل البيانات الجغرافية و بيانات النطاق.",
      content_5:
        "قد نقوم بجمع أنواع مختلفة من البيانات الشخصية عنك من مصادر مختلفة. فيما يلي الفئات الإضافية من البيانات الشخصية التي قد نكون جمعناها من خلال مصادر مختلفة",
      content_6:
        "\tقد نقوم بجمع معلوماتك المالية بما في ذلك البيانات المالية وتفاصيل الحساب المصرفي والتاريخ الائتماني وتاريخ/تفاصيل القروض ومعلومات الراتب.",
    },
    methods: {
      title: "طرق جمع البيانات الشخصية",
      direct: {
        title: "المعلومات التي تقدمها بشكل مباشر (صاحب البيانات).",
        content:
          "وتتم عن طريق تعبئة النموذج الإلكتروني عبر الموقع الإلكتروني، أو عن طريق التواصل معنا عبر القنوات الأخرى مثل (الإيميل والمكالمات الهاتفية).",
      },
      indirect: {
        title: "المعلومات التي نجمعها بشكل غير مباشر عنك",
        content:
          "كمعلوماتك من المنظمات (البنوك، منظمات الإقراض، مقدمي التأمين، شركات الاتصالات)، ومن الشركات الخاصة ذات الملكية الوطنية مثل علم وغيرها.",
      },
    },
  },
  personal_information_collection: {
    title: "المعلومات الشخصية التي نجمعها و ممن  نجمعها",
    what_we_collect: {
      title: " ما الذي قد نجمعه",
      content_1:
        " معلومات الهوية (الاسم بما في ذلك الاسم الأول و الأخير وتاريخ الميلاد ورقم الهوية الوطنية والحالة الاجتماعية)",
      content_2: "المعلومات الديموغرافية: العمر، الجنس.",
      content_3:
        "معلومات الاتصال: العنوان الوطني، عنوان البريد الإلكتروني، رقم (أرقام) الهاتف.",
      content_4:
        " معلومات الشركة (الاسم والعنوان والموقع ونوع الأصول المباعة ورقم السجل التجاري وأرقام الهواتف وعناوين البريد الإلكتروني والمواقع الإلكترونية والبيانات المالية والدخل والقيمة السوقية للأرض).",
      content_5: "بيانات ذات صلة بملفات تعريف الارتباط.",
      content_6:
        "  التسجيل الصوتي والإلكتروني، على سبيل المثال، عند الاتصال بخدمة العملاء لطرح سؤال.",
      content_7:
        "التفاصيل المالية (تفاصيل الحساب البنكي، البيانات المالية، الدخل، التاريخ الائتماني، بيانات طلب القرض أو الائتمان، معلومات الراتب)",
      content_8: " تسجيل الفيديو لأغراض تقديم الخدمة.",
    },
    from_whom: {
      title: "ممن نجمعها",
      content_1: "المعلومات التي تقدمها.",
      content_2:
        "معلوماتك من المنظمات الأعضاء (البنوك، منظمات الإقراض، مقدمي التأمين، شركات الاتصالات)، ومن الشركات الخاصة ذات الملكية الوطنية مثل علم.",
    },
    purpose: {
      title: "الغرض من جمع ومعالجة المعلومات الشخصية",
      subTitle: "نقوم بجمع معلوماتك الشخصية لأغراض مختلفة كما هو مذكور أدناه:",
      content_1: "لأغراض إعداد العملاء / أغراض تسجيل العملاء.",
      content_2: "للتحقق من هويتك.",
      content_3: "لمعالجة طلب التمويل أو التأمين.",
      content_4:
        "لكشف الاحتيال و التحقيق فيها ومنعها من خلال مراقبة وتسجيل الاتصالات الصوتية والالكترونية وفحص الطلبات والمعاملات.",
      content_5:
        "لتسجيل وإظهار كيفية قيامنا بإجراء عملية حل النزاعات والشكاوى والتوصل إلى حلول.",
      content_6:
        "للامتثال للمتطلبات التجارية والقانونية والتنظيمية المفروضة على تمويل الأولى.",
      content_7:
        "لتطوير المنتجات والبحث، ولأي غرض يخضع للقيود المنصوص عليها في هذا الإشعار والقوانين المعمول بها المفروضة على تمويل الأولى.",
      content_8:
        "لتلبية طلباتك، والمعاملات والاتصالات الأخرى حول مواقعنا الإلكترونية وخدماتنا عبر الإنترنت.",
      content_9:
        "قد يتم استخدام بياناتك الشخصية باستثناء البيانات الحساسة لأغراض التسويق.",
      content_10: " قد يتم استخدام بياناتك الشخصية لاتخاذ القرارات تلقائيًا.",
    },
  },
  purpose_collecting_processing: {
    legal_basis: {
      title: "الأساس النظامي لمعالجة البيانات",
      content:
        "تقوم تمويل الأولى بمعالجة بياناتك الشخصية وفقًا لأسس قانونية محددة، تشمل تنفيذ العقود، والامتثال للأنظمة، وحماية المصالح الأساسية، والموافقة، والمصالح المشروعة.",
    },
    data_protection: {
      title: "حماية البيانات الشخصية",
      content:
        "تلتزم تمويل الأولى بحماية بياناتك الشخصية من الوصول أو الاستخدام أو الإفصاح غير المصرح به، وفقًا لمعايير الأمان ومتطلبات الهيئة الوطنية للأمن السيبراني والبنك المركزي السعودي (ساما).",
    },
  },
  data_retention: {
    title: "ما هي مدة احتفاظ تمويل الأولى بالبيانات الشخصية؟",
    content:
      "تحتفظ تمويل الأولى ببياناتك بحسب المدة المحددة في نظام قانون حماية البيانات أو طالما أننا بحاجة إليها لأغراض قانونية وأيضًا للأغراض التنظيمية وفقًا لتعليمات السلطة التنظيمية, مثل مؤسسة النقد العربي السعودي. <br> تقوم تمويل الأولى بمراجعة البيانات التي نحتفظ بها بشكل دوري ونقوم بإخفاء هوية أصحابها أو حذفها بشكل آمن عندما لا تكون هناك حاجة قانونية أو تنظيمية للاحتفاظ به.",
  },
  data_sharing: {
    title: "مع من تشارك تمويل الأولى معلوماتك الشخصية؟",
    content:
      "تشارك تمويل الأولى بياناتك الشخصية مع مختلف المنظمات بما في ذلك برامج التحقق من الهوية، وشركات التحقيق المالي، والبنوك، ومقدمي خدمات السجل الائتماني، ومقدمي الخدمات السحابية الموثوقين، والسلطات التنظيمية في المملكة العربية السعودية الذين توافق على الكشف عن بياناتك الشخصية لهم. قبل مشاركة البيانات الشخصية مع هذه المنظمات الشريكة، نقوم بمراجعة الخدمات التي تقدمها هذه المنظمات ونطلب منها الحفاظ على سرية وأمان البيانات الشخصية وعدم استخدامها لأي غرض باستثناء أداء الخدمات المتفق عليها.\n" +
      "الإفصاح لأسباب قانونية: قد نشارك البيانات الشخصية مع أطراف ثالثة للامتثال للمتطلبات القانونية الصحيحة مثل القانون السعودي أو اللوائح أو أوامر التفتيش أو مذكرات الاستدعاء أو أوامر المحكمة أو الإجراءات القانونية الأخرى. قد تقوم تمويل الأولى بنقل ومعالجة بعض البيانات الشخصية إلى خارج المملكة، وستتخذ جميع الإجراءات اللازمة لضمان أن يتم هذا النقل بما يتوافق مع الأنظمة السارية، وبما يضمن توفير مستوى مناسب من الحماية لبياناتك الشخصية.\n",
  },
  minors_privacy: {
    title: "خصوصية القاصرين",
    content:
      "تهتم تمويل الأولى بحماية خصوصية القاصرين. موقع الويب غير موجه للأفراد الذين تقل أعمارهم عن السن القانونية، ونحن لا نجمع معلومات شخصية عن عمد من هؤلاء الأفراد.",
  },
  changes_notice: {
    title: "هل سنبلغك بالتغييرات التي تطرأ على إشعار الخصوصية هذا؟",
    content:
      "إذا قمنا بتغيير إشعار الخصوصية هذا، فسنخبرك بالتغييرات عن طريق نشر الإصدار المحدث على جميع قنوات الاتصال المعمول بها. تلتزم شركة تمويل الأولى بحماية واحترام خصوصيتك.",
  },
  data_subject_choices: {
    title: "الحقوق المتاحة لأصحاب البيانات الشخصية",
    title_content:
      "بموجب قانون حماية البيانات الشخصية في المملكة العربية السعودية، يحق لأصحاب البيانات الشخصية التمتع بالحقوق التالية. ومع ذلك، سيتم صرف الحقوق المتعلقة بصاحب البيانات وفقًا للالتزامات التنظيمية والقانونية المترتبة على تمويل الأولى.",
    choice_1:
      "الحق في طلب معلومات حول أنشطة المعالجة التي تتم على بياناتهم الشخصية.",
    choice_2: "الحق في طلب الوصول إلى بياناتهم الشخصية.",
    choice_3: "الحق في طلب الحصول علي بياناتهم الشخصية.",
    choice_4: "الحق في طلب مسح البيانات الشخصية في حالات محددة.",
    choice_5: "الحق في سحب الموافقة في حالات محددة.",
    choice_6: "الحق في طلب تصحيح أو تحديث أو استكمال بياناتهم الشخصية.",
    content:
      'لأية استفسارات أو شكاوى، يمكنك التواصل مع مسؤول حماية البيانات عبر تبويب " اتصل بنا " المتوفر على موقعنا.\n',
    para_1:
      "يمكنك إلغاء الموافقة على استلام الرسائل التسويقية في أي وقت من خلال زيارة ملفك الشخصي عبر الموقع الإلكتروني أو تطبيق الهاتف لتمويل الأولى، وذلك بالدخول إلى خيار إدارة العروض وتحديث تفضيلاتك.",
    para_2:
      "يحق لك سحب موافقتك على معالجة بياناتك الشخصية في أي وقت، ما لم توجد مبررات أو متطلبات نظامية تستدعي الاستمرار في المعالجة.",
    para_3:
      'لأية استفسارات أو شكاوى أو طلبات متعلقة بالبيانات الشخصية، يمكنك التواصل مع مسؤول حماية البيانات عبر تبويب " اتصل بنا " المتوفر على موقعنا.',
    para_4:
      "تعمل تمويل الأولى على تنفيذ طلباتك لممارسة حقوقك خلال 30 يومًا، مع إمكانية تمديدها 30 يومًا إضافية عند الحاجة مع إعلامك بالسبب في حال التمديد.",
    para_5:
      "عند عدم الرضا عن معالجة طلبك أو شكواك، أو في حال عدم التجاوب في الوقت المحدد، يمكنك تقديم اعتراض إلى البنك المركزي السعودي (ساما).",
  },
  data_access_correction: {
    title: "طرق الوصول إلى البيانات الشخصية أو تصحيحها أو تعديلها",
    content:
      "إذا كنت تعتقد أن أي معلومات واردة في تقرير الائتمان الشخصي الخاص بك غير دقيقة أو غير كاملة، فيمكنك رفع طلب وإخبارنا على وجه التحديد عن سبب اعتقادك بأنها غير دقيقة أو غير كاملة.\n" +
      'يمكنك التواصل معنا عبر تبويب " اتصل بنا " المتوفر على موقعنا.\n',
  },
  UPLOAD_DOCUMENT: "ارسال مستند",
  APPLY: "تقديم",
  TERMS_AND_CONDITIONS: "الشروط و الاحكام",
  CLOSE: "إغلاق",
  STEP_OFFER: "العرض",
  SUBMIT: "إرسال",
  STEP_CONTRACT: "العقد",
  DISBURSEMENNT: "ارسال المبلغ",
  STEP_DONE: "تم",
  QARAR_COMMENTS: "ملاحظات قرار",
  REJECTION_REASON: "سبب الرفض",
  STEPPER: {
    STATUS: {
      PENDING: "قيد الانتظار",
      ACCEPTED: "مقبول",
      REJECTED: "مرفوض",
      DISBURSED: "تم الصرف",
      SIGNED: "تم التوقيع",
    },
    DESC: {
      SUBMIT_DEFAULT: "تم استلام طلبك وهو قيد المراجعة.",
      SUBMIT_ACCEPTED: "تم التحقق من طلبك وقبوله بنجاح.",
      SUBMIT_PENDING: "طلبك في انتظار التحقق. يرجى الرد على مكالمة IVR.",
      SUBMIT_REJECTED: "للأسف، لم يتم التحقق من طلبك بنجاح.",
      OFFER_DEFAULT: "عرضك جاهز. يرجى مراجعة التفاصيل للمتابعة.",
      OFFER_ACCEPTED: "تم قبول العرض بنجاح. جارٍ المتابعة إلى العقد.",
      OFFER_PENDING: "جارٍ إعداد عرضك. يرجى الانتظار.",
      OFFER_REJECTED: "تم رفض العرض أو انتهت صلاحيته.",
      CONTRACT_DEFAULT: "وقّع العقد لتأكيد موافقتك والمتابعة.",
      CONTRACT_SIGNED: "لقد وقّعت العقد بنجاح.",
      CONTRACT_PENDING: "جارٍ إعداد عقدك. يرجى الانتظار.",
      CONTRACT_REJECTED: "تم رفض العقد أو انتهت صلاحيته.",
      DISBURSEMENT_DEFAULT: "بعد الموافقة على العقد، سيتم إتمام عملية الصرف.",
      DISBURSEMENT_COMPLETED: "تهانينا! تم إتمام عملية الصرف بنجاح.",
    },
  },
  SHARED: {
    SEARCH: "بحث",
    ONE: "١",
    TWO: "٢",
    THREE: "٣",
    FOUR: "٤",
  },
  PROVIDERS: {
    PROVIDERS: "مزود",
    SUBMIT_APPL_SUCEESS: "تم تقديم الطلب بنجاح.",
    SUBMIT_APPL_ERROR: "فشل. يرجى المحاولة مرة أخرى.",
    NO_DATA_FOUND: "لم يتم العثور على بيانات.",
  },
  VOUCHERS: {
    VOUCHERS: "قسائم",
    SHERIZERO_PT1: "٪معدل ربح ٠",
    SHERIZERO_PT2: "يوفر الوصول إلى أكثر من",
    SHERIZERO_PT4: "مدة تبدأ من ٤ إلى ١٢ شهرا.",
    FIVE_THOUSAND: "٥،٠٠٠",
    STARTS_FROM: "يبدأ من",
    APPLY_NOW: "قدم الأن",
    COMING_SOON: "قريبا",
    COMING_SOON_MSG: "هذه الخدمة قادمة قريباً!",
    EIGHTY_FIVE_MERCHANTS: "٨٥ متجر",
    FOUR_HUNDRED_MERCHANTS: "٤٠٠ متجر",
    SHERI_PT1: "معدل النسبة السنوية تبدأ من ١٥٫٠٨٪",
    SHERI_PT2: "مدة تبدأ من ٦ الى ٦٠ شهر",
    MAX_LIMIT: "حد اعلى يصل الى",
    FIVE_HUNDRED_THOUSAND: "٥٠٠،٠٠٠",
    FILL_FORM: "يرجى تعبئة النموذج التالي",
  },
  MERCHANTS: {
    BEST_SELLERS: "الأكثر مبيعاً",
    PROVIDERS: "البطاقات",
    ALL_CARDS: "جميع البطاقات",
    SEARCH_BY_NAME: "ابحث باسم البطاقة",
  },
  PRE: {
    WELCOME: "مرحباً بك في تمويل!",
    DESCRIPTION: "اتبع هذه الخطوات لإكمال إعداد الملف الشخصي:",
    STARTED: "اتبع هذه الخطوات لإكمال إعداد الملف الشخصي:",
    PERSONAL_DATA_HEADING: "بياناتك الشخصية",
    PERSONAL_DATA_DESCRIPTION: "قم بإدارة اسمك ورقم الهوية... إلخ:",
    ADDRESS_DTL_HEADING: "تفاصيل العنوان",
    ADDRESS_DTL_DESCRIPTION: "قم بإدارة مكان إقامتك",
    MARITAL_STATUS_HEADING: "الحالة الاجتماعية",
    MARITAL_STATUS_DESCRIPTION: "قم بإدارة حالتك الاجتماعية وعدد المُعالين",
    ELIGIBILITY_HEADING: "الأهلية",
    ELIGIBILITY_DESCRIPTION: "قم بإدارة تفاصيل عملك وطريقة الدفع",
    INCOMPLETE_STEPS: "يرجى إكمال جميع الخطوات المطلوبة قبل المتابعة مع طلبك.",
  },
};

export default locale;